module.exports = __webpack_public_path__ + "img/Announce_Oct_2025.50819642.jpeg";